import {createStandardActions, GetActions, placeholder, readonly, standardItemsReducer} from '../../utils';
import {createStandardSelectors, getEntities, selector} from '../../selectors';
import {combineReducers} from 'redux';
import {OrderItem} from './joining/orderItem';
import {UpdateItemPictureRequest} from '../../../components/util/ItemPicture/ItemPicture';
import {
  cancelOrder,
  deleteOrder,
  submitOrderStatus,
  updateItemPicture, upsertDeposit,
  upsertOrder
} from '../../../api/inventory/inventoryApi';
import {CommonDispatch} from '../../index';
import {OrderUpdate} from '../../../pages/private/Configuration/OrderManagement/components/OrderModal';
import {createAction} from 'typesafe-actions';

export enum EOrderStatus {
  Unapproved = 0,
  Approved = 1,
  Cancelled = 3
}

export type ConsumerInformation = {
  id: string;
  name: string;
  jobTitle: string;
  emailAddress: string;
  phoneNumber: string;
  everythingFound: boolean;
  everythingFoundComment: string;
  additionalComment: string;
};

export interface Order {
  id: string;
  orderStatus: EOrderStatus;
  approvedById: string | null;
  organization: string;
  consumerInformationId: string | null;
  consumerInformation: ConsumerInformation;
  isWithdrawal: boolean;
  orderItems: OrderItem[];
  submittedAt: string;
  approvedAt: string;
  totalCost: number;
  programId: string;
  houseId: string;
  isFromWarehouse?: boolean;
}

const actions = createStandardActions(placeholder<Order>(), 'ORDER/SET', 'ORDER/SAVE');
const selectors = createStandardSelectors(placeholder<Order>(), s => getEntities(s).orders);
const withdrawals = selector(s => selectors.getAsArray(s).filter(order => order.isWithdrawal));
const deposits = selector(s => selectors.getAsArray(s).filter(order => !order.isWithdrawal));
const deleteOrderAction = createAction('ORDER/DELETE')<string>();
export type OrderActions = GetActions<typeof actions> | ReturnType<typeof deleteOrderAction>;
export const orders = combineReducers({items: standardItemsReducer<Order, OrderActions>(actions)
    .handleAction(deleteOrderAction, (state, action) => {
      const newState = {...state};
      delete newState[action.payload as any];
      return newState;
  })
});
export const orderStore = readonly({
  selectors: {
    ...selectors,
    withdrawals: withdrawals,
    deposits: deposits,
    unapproved: selector(s => withdrawals(s).filter(order => order.orderStatus === EOrderStatus.Unapproved)),
    approved: selector(s => withdrawals(s).filter(order => order.orderStatus === EOrderStatus.Approved)),
    cancelled: selector(s => withdrawals(s).filter(order => order.orderStatus === EOrderStatus.Cancelled)),
    notCancelled: selector(s => withdrawals(s).filter(order => order.orderStatus !== EOrderStatus.Cancelled)),
    getTotalStoreItems: selector(s => (order: Order) =>
      order.orderItems.reduce((acc, oi) => acc + (oi.storeQuantity || 0) + oi.itemOptions.reduce((a, io) => a + io.quantity, 0), 0)),
    getTotalWarehouseItems: selector(s => (order: Order) =>
      order.orderItems.reduce((acc, oi) => acc + (oi.warehouseQuantity || 0), 0))
  },
  actions: {
    ...actions,
    upsert: (order: OrderUpdate) => async (dispatch: CommonDispatch) => {
      const response = await upsertOrder(order);
      dispatch(orderStore.actions.save(response));
    },
    upsertDeposit: (deposit: Order) => async (dispatch: CommonDispatch) => {
      const response = await upsertDeposit(deposit);
      dispatch(orderStore.actions.save(response));
    },
    updateOrderStatus: (id: string, orderStatus: EOrderStatus) => async (dispatch: CommonDispatch) => {
      console.log(JSON.stringify(orderStatus))
      const order = await submitOrderStatus(id, orderStatus);
      dispatch(orderStore.actions.save(order));
    },
    cancelOrder: (id: string) => async (dispatch: CommonDispatch) => {
      const order = await cancelOrder(id);
      dispatch(orderStore.actions.save(order));
    },
    deleteOrder: (id: string) => async (dispatch: CommonDispatch) => {
      await deleteOrder(id);
      dispatch(deleteOrderAction(id));
    }
  }
});
